<template>
  <div class="wrap">
    <!-- browser-suggestion -->
    <browser-suggestion></browser-suggestion>
    <!-- browser-suggestion -->

    <div class="wrapper">
      <div class="form-title-wrap">
        <form-title :tip="tip"></form-title>
      </div>

      <div class="operation-btn">
        <el-button
          type="primary"
          v-show="isSaveResumeInfo"
          @click="saveResumeInfo()"
          ><i class="el-icon-check el-icon--left"></i>保存</el-button
        >
        <el-button
          type="primary"
          v-show="isUpdateResumeInfo"
          @click="updateResumeInfo()"
          ><i class="el-icon-edit el-icon--left"></i>修改</el-button
        ><el-button
          type="primary"
          v-show="isApplyResumeInfo"
          @click="applyPost()"
          >投递简历</el-button
        >
        <el-button type="info" v-show="isBackPage" @click="backPage()"
          ><i class="el-icon-back el-icon--left"></i>返回</el-button
        >
        <el-button v-show="isResetAllFields" @click="resetAllFields()"
          ><i class="el-icon-refresh-left el-icon--left"></i>重置</el-button
        >
        <el-button v-show="iscancelSave" @click="cancelSave()"
          ><i class="el-icon-close el-icon--left"></i>取消</el-button
        >
      </div>

      <div class="person-register clearfix">
        <!-- 左边菜单区域 -->
        <div class="tab-nav">
          <ul style="border: 1px solid #ebebeb">
            <li
              class="tab-nav-li"
              v-for="(item, index) in navList"
              :key="index"
              @click="tabNav(item.index, item.code)"
            >
              <a
                :class="[item.code == navCode ? 'active' : '', 'tab-nav-link']"
              >
                <img
                  v-if="item.progress_rate == '-1'"
                  src="../../assets/image/tb01.png"
                />
                <img
                  v-if="item.progress_rate == '0'"
                  src="../../assets/image/psn_require.png"
                />
                <img
                  v-if="item.progress_rate == '25'"
                  src="../../assets/image/tb04.png"
                />
                <img
                  v-if="item.progress_rate == '75'"
                  src="../../assets/image/tb02.png"
                />
                <span>{{ item.title }}</span>
                <i
                  v-if="item.validate == 1"
                  class="icon-warn el-icon-warning-outline"
                ></i>
              </a>
            </li>
          </ul>

          <div>
            <div class="tips">
              <div class="tips-title">图例说明</div>
              <div class="tips-content">
                <table class="tips-table">
                  <tbody>
                    <tr>
                      <td>
                        <img src="../../assets/image/psn_require.png" />
                        必填项
                      </td>
                      <td>
                        <img src="../../assets/image/tb01.png" />
                        选填项
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!--
          <div>
            <div class="tips">
              <div class="tips-title">
                图例说明
              </div>
              <div class="tips-content">
                <table class="tips-table">
                  <tbody>
                    <tr>
                      <td>
                        <img src="../../assets/image/tb02.png" />
                        已填写
                      </td>
                      <td>
                        <img src="../../assets/image/tb03.png" />
                        未填写
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <img src="../../assets/image/tb04.png" />
                        不完整
                      </td>
                      <td>
                        <img src="../../assets/image/tb01.png" />
                        选填项
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="goBackResumeList">
                <el-button @click="goBackResumeList">返回简历列表</el-button>
              </div>
            </div>
          </div>
          -->
        </div>

        <div class="right-main-psninfo">
          <!-- 新增 -->
          <!-- 个人信息 -->
          <person-form
            ref="personForm"
            :VOStatus="VOStatus"
            v-show="ins == 0"
          />
          <!-- 家庭成员 -->
          <family-member
            ref="familyForm"
            :VOStatus="VOStatus"
            v-show="ins == 1"
          />
          <!-- 主要业绩 -->
          <!-- <kpi-rp ref="newkpiRpForm" v-show="ins == 2" /> -->
          <!-- 学习经历 -->
          <study-exp ref="studyForm" :VOStatus="VOStatus" v-show="ins == 3" />
          <!-- 实习经历 -->
          <!-- <practice-exp ref="newpracticeForm" v-show="ins == 4" /> -->
          <!-- 工作经历 -->
          <work-exp ref="workForm" :VOStatus="VOStatus" v-show="ins == 5" />
          <!-- 奖励信息 -->
          <reward-info
            ref="rewardForm"
            :VOStatus="VOStatus"
            v-show="ins == 6"
          />
          <!-- 附件 -->
          <attachment-com
            ref="attchmentForm"
            :VOStatus="VOStatus"
            v-show="ins == 7"
          />
        </div>
      </div>
      <div class="dialog">
        <el-dialog
          title="职位申请"
          :visible.sync="dialogVisible"
          width="540px"
          center
          close-on-click-modal
          :show-close="false"
          :modal-append-to-body="false"
        >
          <div class="diglog-content">
            <div class="orgname">
              <span>岗位已投递人数:</span>
              {{ totalPsn }}
            </div>
            <div class="orgname">
              <span>应聘单位:</span>
              {{ resumeSelectData.orgname }}
            </div>
            <div class="postname">
              <span>应聘职位:</span>
              {{ resumeSelectData.postname }}
            </div>

            <div class="tips-su">
              <p>注意事项：</p>
              <p>
                1.同一家单位只能投递一个岗位，不能重复投递，请仔细核对要投递的单位和职位信息；
              </p>
              <p>
                2.简历一经投递，无法对投递的内容进行修改，修改简历信息将在下次投递时生效；
              </p>
              <p>3.核对无误后，请点击确认按钮。</p>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button
              style="background: #01539f"
              type="primary"
              @click="confirmSend"
            >
              确认投递
            </el-button>
            <el-button @click="dialogVisible = false">取 消</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
// 标题
import formTitle from "../common/formTitle";
// 个人信息
import personForm from "../common/personForm";
// 家庭成员
import familyMember from "../common/familyMember";
// import kpiRp from '../common/kpiAndRewardAndPunishment'
import studyExp from "../common/studyExp";
// 工作经历
import workExp from "../common/workExp";
// 奖励信息
import rewardInfo from "../common/rewardInfo";
// 附件
import attachmentCom from "../common/attachment";
// import practiceExp from '../common/practiceExp'

import { saveResume, resumeDetail } from "../request/resumeApi";

// import { resumeDetail } from '../request/resumeApi'

import { MessageBox, Message } from "element-ui";

import { mapState, mapMutations } from "vuex";

import { sendmyResume, queryTotalPsn } from "../request/api";
// import func from 'vue-editor-bridge'
export default {
  name: "personInfo",
  components: {
    formTitle,
    personForm,
    familyMember,
    // kpiRp,
    studyExp,
    workExp,
    rewardInfo,
    attachmentCom,
    // practiceExp
  },

  //   public abstract interface VOStatus
  // {
  //   public static final int UNCHANGED = 0;
  //   public static final int UPDATED = 1;
  //   public static final int NEW = 2;
  //   public static final int DELETED = 3;
  // }

  data() {
    return {
      VOStatus: "view", // 页面状态 new 新建 edit 修改 view 查看
      // 全局返回路由
      globalBackRoute: {},
      tip: "我的简历",
      navCode: "personForm",
      navList: [
        {
          index: 0,
          title: "个人信息",
          progress_rate: 0,
          code: "personForm",
          validate: 0,
          icon: "../icons/icon/个人信息.png",
        },
        {
          index: 1,
          title: "主要家庭成员",
          progress_rate: -1,
          code: "familyMember",
          validate: 0,
          icon: "../icons/icon/家庭成员.png",
        },
        // { index: 2, title: '主要业绩', progress_rate: -1, code: 'kpiRp', validate: 0, icon: '../icons/icon/主要业绩.png' },
        {
          index: 3,
          title: "学习经历(从高中起填)",
          progress_rate: 0,
          code: "studyExp",
          validate: 0,
          icon: "../icons/icon/学习经历.png",
        },
        // { index: 4, title: '实习经历', progress_rate: -1, code: 'practiceExp', validate: 0, icon: '../icons/icon/学习经历.png' },
        {
          index: 5,
          title: "工作经历",
          progress_rate: -1,
          code: "workExp",
          validate: 0,
          icon: "../icons/icon/实习工作经历.png",
        },
        {
          index: 6,
          title: "奖励情况",
          progress_rate: -1,
          code: "rewardInfo",
          validate: 0,
          icon: "../icons/icon/奖励情况.png",
        },
        {
          index: 7,
          title: "电子附件",
          progress_rate: -1,
          code: "attachmentCom",
          validate: 0,
          icon: "../icons/icon/电子附件.png",
        },
      ],
      ins: 0,
      myresumePerson: {},
      myresumeStudy: [],
      myresumeWork: [],
      myresumeFamily: [],
      myresumeAward: [],
      myresumeAttch: [],
      personObj: {},
      //
      flag: 0,
      oid: 0,
      soid: 0,
      totalPsn: 0,
      dialogVisible: false,
    };
  },
  methods: {
    ...mapMutations(["clearResumeSelectData"]),
    formAllValidate() {
      // 表单验证
    },
    formGetAllValue() {
      // 页面获取值
    },
    formGetValue() {
      // 页面获取值
    },
    formSetAllValue() {
      // 设置所有页面的值
    },
    formSetValue() {
      // 设置单个页面的值
    },
    //保存
    saveResumeInfo() {
      // 保存数据——调整为保存时不做任何校验，只有投递简历时才做校验
      // 开始提交数据
      // 个人信息
      var hrrm_myresume_h = this.$refs.personForm.formGetValue();
      // 家庭成员
      var hrrm_myresume_family = this.$refs.familyForm.formGetValue();
      // 学习经历
      var hrrm_myresume_edu = this.$refs.studyForm.formGetValue();
      // 工作经历
      var hrrm_myresume_work = this.$refs.workForm.formGetValue();
      // 奖励信息
      var hrrm_myresume_award = this.$refs.rewardForm.formGetValue();
      // 附件
      var hrrm_myresume_attch = this.$refs.attchmentForm.formGetValue();

      // 计算简历的完成度
      let total = 0.0;
      let notNull = 0.0;

      // 遍历
      try {
        // 个人信息
        for (let key in hrrm_myresume_h) {
          total++;
          if (hrrm_myresume_h[key] === 0) {
            notNull++;
            continue;
          }
          if (hrrm_myresume_h[key] && hrrm_myresume_h != "") {
            notNull++;
          }
        }
        //家庭成员
        if (hrrm_myresume_family && hrrm_myresume_family.length > 0) {
          for (let parentIndex in hrrm_myresume_family) {
            for (let childIndex in hrrm_myresume_family[parentIndex]) {
              total++;
              if (hrrm_myresume_family[parentIndex][childIndex] === 0) {
                notNull++;
                continue;
              }
              if (
                hrrm_myresume_family[parentIndex][childIndex] &&
                hrrm_myresume_family[parentIndex][childIndex] != ""
              ) {
                notNull++;
              }
            }
          }
        }
        // 学习经历
        if (hrrm_myresume_edu && hrrm_myresume_edu.length > 0) {
          for (let parentIndex in hrrm_myresume_edu) {
            for (let childIndex in hrrm_myresume_edu[parentIndex]) {
              total++;
              if (hrrm_myresume_edu[parentIndex][childIndex] === 0) {
                notNull++;
                continue;
              }
              if (
                hrrm_myresume_edu[parentIndex][childIndex] &&
                hrrm_myresume_edu[parentIndex][childIndex] != ""
              ) {
                notNull++;
              }
            }
          }
        }
        // 工作经历
        if (hrrm_myresume_work && hrrm_myresume_work.length > 0) {
          for (let parentIndex in hrrm_myresume_work) {
            for (let childIndex in hrrm_myresume_work[parentIndex]) {
              total++;
              if (hrrm_myresume_work[parentIndex][childIndex] === 0) {
                notNull++;
                continue;
              }
              if (
                hrrm_myresume_work[parentIndex][childIndex] &&
                hrrm_myresume_work[parentIndex][childIndex] != ""
              ) {
                notNull++;
              }
            }
          }
        }
        // 奖励信息
        if (hrrm_myresume_award && hrrm_myresume_award.length > 0) {
          for (let parentIndex in hrrm_myresume_award) {
            for (let childIndex in hrrm_myresume_award[parentIndex]) {
              total++;
              if (hrrm_myresume_award[parentIndex][childIndex] === 0) {
                notNull++;
                continue;
              }
              if (
                hrrm_myresume_award[parentIndex][childIndex] &&
                hrrm_myresume_award[parentIndex][childIndex] != ""
              ) {
                notNull++;
              }
            }
          }
        }
        // 附件
        if (hrrm_myresume_attch && hrrm_myresume_attch.length > 0) {
          for (let parentIndex in hrrm_myresume_attch) {
            for (let childIndex in hrrm_myresume_attch[parentIndex]) {
              total++;
              if (hrrm_myresume_attch[parentIndex][childIndex] === 0) {
                notNull++;
                continue;
              }
              if (
                hrrm_myresume_attch[parentIndex][childIndex] &&
                hrrm_myresume_attch[parentIndex][childIndex] != ""
              ) {
                notNull++;
              }
            }
          }
        }

        // 设置
        let resumecompl = (notNull / total) * 100;

        hrrm_myresume_h["resumecompl"] = parseInt(resumecompl);

        // 处理籍贯
        if (hrrm_myresume_h["hometown"] && hrrm_myresume_h["hometown"][2]) {
          hrrm_myresume_h["hometown"] = hrrm_myresume_h["hometown"][2];
        }
      } catch (error) {
        console.log(error);
      }

      let params = {
        flag: this.getflag,
        oid: this.getoid,
        soid: this.getsoid,
        hrrm_myresume_h: JSON.stringify(hrrm_myresume_h),
        hrrm_myresume_family: JSON.stringify(hrrm_myresume_family),
        hrrm_myresume_edu: JSON.stringify(hrrm_myresume_edu),
        hrrm_myresume_work: JSON.stringify(hrrm_myresume_work),
        hrrm_myresume_award: JSON.stringify(hrrm_myresume_award),
        hrrm_myresume_attch: JSON.stringify(hrrm_myresume_attch),
      };

      saveResume(params).then((res) => {
        if (res.success) {
          Message({
            type: "success",
            message: res.message,
          });
          this.initPage(
            "view",
            res.data.hrrm_myresume_h["soid"].key,
            res.data.hrrm_myresume_h["oid"].key
          );
        } else {
          Message({
            message: res.message,
            type: "error",
            duration: 3 * 1000,
          });
        }
      });
    },
    updateResumeInfo() {
      this.VOStatus = "edit";
      // this.initPage('edit', this.$route.query.soid, this.$route.query.oid);
    },
    cancelSave() {
      // 重新初始化页面
      this.VOStatus = "view";
      // this.initPage('view', this.$route.query.soid, this.$route.query.oid);
    },
    backPage() {
      if (this.VOStatus == "edit") {
        MessageBox.confirm("确认返回!", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$router.push(this.globalBackRoute);
        });
      } else if (this.VOStatus == "new") {
        MessageBox.confirm("确认返回!", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$router.push(this.globalBackRoute);
        });
      } else {
        this.$router.push(this.globalBackRoute);
      }
    },
    //编辑赋值
    assignData() {
      let params = {
        soid: this.$route.query.soid,
      };
      resumeDetail(params).then((res) => {
        // console.log(res.data)
        this.personObj = res.data.hrrm_myresume_h;
        this.$refs.familyForm.assinList = res.data.hrrm_myresume_family;
        this.$refs.rewardForm.assinList = res.data.hrrm_myresume_award;
        this.$refs.studyForm.assinList = res.data.hrrm_myresume_edu;
        this.$refs.workForm.assinList = res.data.hrrm_myresume_work;
        this.$refs.attchmentForm.assinList = res.data.hrrm_myresume_attch;
      });
    },

    tabNav(index, code) {
      this.ins = index;
      this.navCode = code;
    },
    //返回简历列表
    goBackResumeList() {
      this.$router.push("/resumeList");
    },
    default() {
      this.$nextTick(() => {
        // dom元素更新后执行，因此这里能正确打印更改之后的值
        this.$refs.attchmentForm.attchmentForm;
      });
    },
    // 重置所有表单
    resetAllFields() {
      //
      // resetAllFields
      if (this.$refs.personForm) {
        this.$refs.personForm.resetFormData();
      }
      // 家庭成员
      if (this.$refs.familyForm) {
        this.$refs.familyForm.resetFormData();
      }
      // 学习经历
      if (this.$refs.studyForm) {
        this.$refs.studyForm.resetFormData();
      }
      // 工作经历
      if (this.$refs.workForm) {
        this.$refs.workForm.resetFormData();
      }
      // 奖励信息
      if (this.$refs.rewardForm) {
        this.$refs.rewardForm.resetFormData();
      }
    },
    // 清理数据
    clearAllFormData() {
      // resetAllFields
      if (this.$refs.personForm) {
        this.$refs.personForm.$refs["personForm"].resetFields();
      }
      // 家庭成员
      if (this.$refs.familyForm) {
        this.$refs.familyForm.clearFormData();
      }
      // 学习经历
      if (this.$refs.studyForm) {
        this.$refs.studyForm.clearFormData();
      }
      // 工作经历
      if (this.$refs.workForm) {
        this.$refs.workForm.clearFormData();
      }
      // 奖励信息
      if (this.$refs.rewardForm) {
        this.$refs.rewardForm.clearFormData();
      }
    },
    initPage(VOStatus, soid, oid) {
      if (!VOStatus) {
        return;
      }
      this.VOStatus = VOStatus;
      this.soid = soid;
      this.oid = oid;
      // console.log(`soid: ${soid}`);
      if (VOStatus == "view") {
        // console.log('view');
        if (!soid) {
          return;
        }
        // 拉取数据赋值
        this.loadPsnInfo(soid);
      } else if (VOStatus == "edit") {
        // console.log('edit');
        if (!soid) {
          return;
        }
        // 拉取数据赋值
        this.loadPsnInfo(soid);
      } else if (VOStatus == "new") {
        // console.log('new');
        this.clearAllFormData();
        this.VOStatus = "new";
      } else {
        this.VOStatus = "view";
      }
    },
    loadPsnInfo(soid) {
      // 拉取简历数据
      resumeDetail({
        soid,
      }).then((res) => {
        if (res.success) {
          // console.log(res)
          // 个人信息
          this.$refs.personForm.setFormDatas(res.data.hrrm_myresume_h);
          // 家庭成员
          this.$refs.familyForm.setFormDatas(res.data.hrrm_myresume_family);
          // 学习经历
          this.$refs.studyForm.setFormDatas(res.data.hrrm_myresume_edu);
          // 工作经历
          this.$refs.workForm.setFormDatas(res.data.hrrm_myresume_work);
          // 奖励信息
          this.$refs.rewardForm.setFormDatas(res.data.hrrm_myresume_award);
          // 附件
          this.$refs.attchmentForm.setFormDatas(res.data.hrrm_myresume_attch);
        }
      });
    },
    //简历投递
    applyPost() {

      // 验证数据
      var validateAll = [];
      // 个人信息
      validateAll.push(this.$refs.personForm.formAllValidate());
      // 家庭成员
      validateAll.push(this.$refs.familyForm.formAllValidate());
      // 学习经历
      validateAll.push(this.$refs.studyForm.formAllValidate());
      // 工作经历
      validateAll.push(this.$refs.workForm.formAllValidate());
      // 奖励信息
      validateAll.push(this.$refs.rewardForm.formAllValidate());
      // 附件
      validateAll.push(this.$refs.attchmentForm.formAllValidate());

      Promise.all(validateAll).then(
        function (values) {
          // 建立索引
          this.navList.forEach((nav, navIndex) => {
            for (let item of values) {
              if (item.type == nav.code) {
                item["index"] = navIndex;
              }
            }
          });
          // let isFail = false;
          for (let item of values) {
            if (item.status == "fail") {
              this.navList[0].validate = 1;
              // 获取提示语
              Message({
                message: item.msg,
                type: "error",
                duration: 5 * 1000,
              });
              // isFail = true;
              return;
            } else if (item.status == "ok") {
              this.navList[0].validate = 0;
            }
          }
          // }
          // if (isFail) {
          // return;
          // }

          // 开始提交数据
          // // 个人信息
          var hrrm_myresume_h = this.$refs.personForm.formGetValue();
          // // 家庭成员
          // validateAll.push();
          var hrrm_myresume_family = this.$refs.familyForm.formGetValue();
          // // 学习经历
          // validateAll.push(this.$refs.studyForm.formAllValidate());
          var hrrm_myresume_edu = this.$refs.studyForm.formGetValue();
          // // 工作经历
          // validateAll.push(this.$refs.workForm.formAllValidate());
          var hrrm_myresume_work = this.$refs.workForm.formGetValue();
          // // 奖励信息
          // validateAll.push(this.$refs.rewardForm.formAllValidate());
          var hrrm_myresume_award = this.$refs.rewardForm.formGetValue();
          // // 附件
          // validateAll.push(this.$refs.attchmentForm.formAllValidate());
          var hrrm_myresume_attch = this.$refs.attchmentForm.formGetValue();

          // 计算简历的完成度
          let total = 0.0;
          let notNull = 0.0;

          // 遍历
          try {
            // 个人信息
            for (let key in hrrm_myresume_h) {
              total++;
              if (hrrm_myresume_h[key] === 0) {
                notNull++;
                continue;
              }
              if (hrrm_myresume_h[key] && hrrm_myresume_h != "") {
                notNull++;
              }
            }
            //家庭成员
            if (hrrm_myresume_family && hrrm_myresume_family.length > 0) {
              for (let parentIndex in hrrm_myresume_family) {
                for (let childIndex in hrrm_myresume_family[parentIndex]) {
                  total++;
                  if (hrrm_myresume_family[parentIndex][childIndex] === 0) {
                    notNull++;
                    continue;
                  }
                  if (
                    hrrm_myresume_family[parentIndex][childIndex] &&
                    hrrm_myresume_family[parentIndex][childIndex] != ""
                  ) {
                    notNull++;
                  }
                }
              }
            }
            // 学习经历
            if (hrrm_myresume_edu && hrrm_myresume_edu.length > 0) {
              for (let parentIndex in hrrm_myresume_edu) {
                for (let childIndex in hrrm_myresume_edu[parentIndex]) {
                  total++;
                  if (hrrm_myresume_edu[parentIndex][childIndex] === 0) {
                    notNull++;
                    continue;
                  }
                  if (
                    hrrm_myresume_edu[parentIndex][childIndex] &&
                    hrrm_myresume_edu[parentIndex][childIndex] != ""
                  ) {
                    notNull++;
                  }
                }
              }
            }
            // 工作经历
            if (hrrm_myresume_work && hrrm_myresume_work.length > 0) {
              for (let parentIndex in hrrm_myresume_work) {
                for (let childIndex in hrrm_myresume_work[parentIndex]) {
                  total++;
                  if (hrrm_myresume_work[parentIndex][childIndex] === 0) {
                    notNull++;
                    continue;
                  }
                  if (
                    hrrm_myresume_work[parentIndex][childIndex] &&
                    hrrm_myresume_work[parentIndex][childIndex] != ""
                  ) {
                    notNull++;
                  }
                }
              }
            }
            // 奖励信息
            if (hrrm_myresume_award && hrrm_myresume_award.length > 0) {
              for (let parentIndex in hrrm_myresume_award) {
                for (let childIndex in hrrm_myresume_award[parentIndex]) {
                  total++;
                  if (hrrm_myresume_award[parentIndex][childIndex] === 0) {
                    notNull++;
                    continue;
                  }
                  if (
                    hrrm_myresume_award[parentIndex][childIndex] &&
                    hrrm_myresume_award[parentIndex][childIndex] != ""
                  ) {
                    notNull++;
                  }
                }
              }
            }
            // 附件
            if (hrrm_myresume_attch && hrrm_myresume_attch.length > 0) {
              for (let parentIndex in hrrm_myresume_attch) {
                for (let childIndex in hrrm_myresume_attch[parentIndex]) {
                  total++;
                  if (hrrm_myresume_attch[parentIndex][childIndex] === 0) {
                    notNull++;
                    continue;
                  }
                  if (
                    hrrm_myresume_attch[parentIndex][childIndex] &&
                    hrrm_myresume_attch[parentIndex][childIndex] != ""
                  ) {
                    notNull++;
                  }
                }
              }
            }

            // 设置
            let resumecompl = (notNull / total) * 100;

            hrrm_myresume_h["resumecompl"] = parseInt(resumecompl);

            // 处理籍贯
            if (hrrm_myresume_h["hometown"] && hrrm_myresume_h["hometown"][2]) {
              hrrm_myresume_h["hometown"] = hrrm_myresume_h["hometown"][2];
            }
          } catch (error) {
            console.log(error);
          }
          this.getTotalPsn();
          this.dialogVisible = true;
        }.bind(this)
      );
    },

    //根据发布岗位id获取发布中的公告然后查询投递人数
    getTotalPsn() {
      if (this.resumeSelectData.postoid == "") {
        this.$message({
          message: "请选择一个岗位!",
          type: "warning",
        });
        return;
      }
      let data = {
        postoid: this.resumeSelectData.postoid,
      };
      queryTotalPsn(data).then((response) => {
        this.totalPsn = response.data;
      });
    },
    //确认投递
    confirmSend() {
      if (this.resumeSelectData.postoid == "") {
        this.$message({
          message: "请选择一个岗位!",
          type: "warning",
        });
        return;
      }

      // 必须显示才能点击
      if (!this.dialogVisible) {
        return;
      }
      this.dialogVisible = false;
      var soid = this.$route.query.soid;
      var params = {
        soid,
        postoid: this.resumeSelectData.postoid,
      };

      // 投递
      sendmyResume(params).then((res) => {
        console.log(res);
        if (!res.success) {
          this.$message({
            message: res.message,
            type: "warning",
          });
          return;
        } else {
          this.$message({
            message: `投递成功`,
            type: "info",
          });
        }
      });
    },
  },
  mounted() {
    // 判断url参数中是否存在soid
    // this.$route.query.soid
    // this.$route.query.oid
    // this.$route.query.VOStatus
    this.initPage(
      this.$route.query.VOStatus,
      this.$route.query.soid,
      this.$route.query.oid
    );
    // this.default()
    // console.log(this.$route.query.oid)
    // console.log(this.$route.query.soid)
    // console.log(this.$store)
    this.$store.dispatch("popBackRoute").then((route) => {
      if (route) {
        this.globalBackRoute = route;
        // this.$router.push(route);
      }
    });
  },
  computed: {
    ...mapState(["resumeSelectData"]),

    isSaveResumeInfo: function () {
      if (this.VOStatus == "edit") {
        return true;
      } else if (this.VOStatus == "new") {
        return true;
      }
      return false;
    },
    isUpdateResumeInfo: function () {
      if (this.VOStatus == "view") {
        return true;
      }
      return false;
    },
    isResetAllFields: function () {
      if (this.VOStatus == "new") {
        return true;
      }

      return false;
    },
    iscancelSave: function () {
      // if(this.VOStatus == 'edit') {
      //   return true;
      // }
      return false;
    },
    isBackPage: function () {
      // 是否全局导航
      if (!this.globalBackRoute) {
        return false;
      }
      if (
        typeof this.globalBackRoute == "object" &&
        JSON.stringify(this.globalBackRoute) == "{}"
      ) {
        return false;
      }
      if (this.VOStatus == "new") {
        return true;
      } else if (this.VOStatus == "edit") {
        return true;
      } else if (this.VOStatus == "view") {
        return true;
      }
      return false;
    },
    getflag: function () {
      if (this.VOStatus == "edit") {
        return 1;
      }
      return 0;
    },
    getoid: function () {
      if (this.VOStatus == "edit") {
        return this.oid;
      }
      return 0;
    },
    getsoid: function () {
      if (this.VOStatus == "edit") {
        return this.soid;
      }
      return 0;
    },

    isApplyResumeInfo: function () {
      if (this.VOStatus == "view" && this.resumeSelectData.postoid > 0) {
        return true;
      }
      return false;
    },
  },
  //页面关闭之前
  beforeDestroy() {
    //清空岗位缓存
    this.clearResumeSelectData();
  },
};
</script>

<style lang="scss"  >
// 页面样式
.wrap {
  width: 100%;
  padding-left: calc(100vw - 100%);

  .wrapper {
    width: 1200px;
    margin: 0 auto;
    // margin-top: 100px;
    margin-bottom: 40px;

    .form-title-wrap {
      line-height: 40px;
      margin-bottom: 12px;
      background: #fff;
      border-radius: 4px;
      padding-left: 12px;
      padding-right: 12px;
    }

    .operation-btn {
      padding-left: 12px;
      padding-right: 12px;
      padding-top: 12px;
      text-align: right;
      background: #fff;

      button:active {
        opacity: 0.5;
      }

      .el-button {
        border: none;
        border-radius: 0px;
      }
    }

    .person-register {
      position: relative;
      background: #fff;
      padding-top: 12px;
      padding-bottom: 20px;
      padding-left: 12px;
      padding-right: 12px;

      .tab-nav {
        width: 200px;
        float: left;
        margin-bottom: 20px;

        a {
          text-decoration: none;
        }

        .tab-nav-link {
          position: relative;
          display: block;
          height: 56px;
          line-height: 56px;
          padding-left: 12px;
          color: rgba(0, 0, 0, 0.85);
        }

        img {
          height: 18px;
          width: 18px;
          margin-top: -4px;
        }

        .tab-nav-link span {
          margin-left: 8px;
        }

        ul .tab-nav-link:hover {
          cursor: pointer;
          background: #01539f;
          color: white;
          opacity: 0.85;
        }
        ul .tab-nav-link:active {
          opacity: 0.5;
        }
        // 鼠标选中时样式
        ul .tab-nav-link.active {
          cursor: pointer;
          background: #01539f;
          color: white;
        }

        .tab-nav-link .icon-warn {
          position: absolute;
          font-size: 18px;
          right: 6px;
          top: 50%;
          margin-top: -9px;
          color: rgba(255, 0, 0, 0.8);
        }

        .tips {
          height: auto;
          margin-top: 25px;

          .tips-title {
            height: 48px;
            background: #f5f5f5;
            line-height: 48px;
            border: 1px solid #ebebeb;
          }
          .tips-title:before {
            content: "|";
            color: #01539f;
            font-weight: bold;
            margin-left: 17px;
          }
          .tips-content {
            .tips-table {
              width: 199px;
              box-sizing: border-box;
              text-align: center;

              img {
                height: 18px;
                height: 18px;
              }

              tbody {
                tr {
                  td {
                    border: 1px solid #ebebeb;
                    height: 50px;
                    vertical-align: middle;
                  }
                }
              }
            }
          }
        }
        .goBackResumeList {
          margin-top: 20px;
          text-align: center;
        }
      }

      // 右边区域
      .right-main-psninfo {
        margin-left: 200px;
      }
    }

    .dialog {
      .diglog-content {
        height: 245px;
        color: rgba(0, 0, 0, 0.85);

        .orgname {
          height: 40px;
          line-height: 40px;
          font-size: 18px;

          // 超出省略号
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .postname {
          height: 40px;
          line-height: 40px;
          font-size: 18px;

          // 超出省略号
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .tips-su {
          // height: 40px;
          line-height: 40px;
          font-size: 12px;
          color: rgba(255, 0, 0, 0.6);

          p {
            margin: 0px;
          }
        }
      }

      .el-dialog__header {
        background: #01539f;
      }

      .el-dialog__title {
        color: white;
      }
    }
  }
}

.personinfo-card {
  // line-height: 40px;
  width: 960px;
  margin-left: 20px;
  margin-right: 20px;
  .card-title {
    position: relative;

    // border-bottom: 1px solid #ebebeb;
    margin-bottom: 20px;

    .icon {
      display: inline-block;
      height: 40px;
      vertical-align: middle;
    }

    .title {
      height: 40px;
      line-height: 40px;
      display: inline-block;
      font-size: 18px;
      font-weight: bold;
      color: #01539f;
      vertical-align: middle;
    }

    &::after {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      bottom: -12px;
      height: 1px;
      background: #ebebeb;
    }

    .opt-right {
      position: absolute;
      right: 12px;
      top: 0px;
      height: 40px;
      line-height: 40px;
    }
  }

  .card-body {
    .body-item {
      border: 1px solid #eee;
      border-radius: 12px;
      padding: 12px;
      margin-bottom: 20px;
    }

    .body-item-tools {
      height: 30px;
      .delete {
        float: right;
        margin-top: 6px;
        font-size: 18px;
        color: rgba(255, 0, 0, 0.85);
        cursor: pointer;
      }

      .delete:hover {
        color: rgba(255, 0, 0);
      }

      .delete:active {
        opacity: 0.5;
      }
    }

    .form_data {
    }
  }
}

::v-deep .el-input {
  width: 295px;
  height: 40px;
  margin-right: 32px;
}
::v-deep .el-form-item {
  margin-bottom: 10px;
}
::v-deep .el-form--label-top .el-form-item__label {
  padding: 0;
}
</style>
